const state = {
    stageList: [], // 获取所有学段数据
    stageSubjectList: [], // 学段学科
    institutionByBrand: {}, // 组织信息
    scoreMode: 0, // 系统学时学分配置
};

const getters = {};

const actions = {
    // 获取所有学段数据
    getStageList({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            if (state.stageList.length) {
                resolve(state.stageList);
                return;
            }
            G_transmit('stagesList', {
                name: 'stagesList',
                queries: {
                    withAllStage: false
                }
            }).then((res) => {
                let data = res.data || [];

                commit('meta', {
                    stageList: data
                })
                resolve(data);
            }).catch((err) => {
                reject(err);
            })
        })
    },
    // 获取所有学段学科的数据
    getStageRefSubject({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            if (state.stageSubjectList.length) {
                resolve(state.stageSubjectList);
                return;
            }
            G_transmit('listStageRefSubject', {
                queries: {
                    withAllStage: false,
                    withAllSubject: false,
                    withMultipleStage: false
                }
            }).then((res) => {
                let data = res.data || [];
                commit('meta', {
                    stageSubjectList: data
                })
                resolve(data);
            }).catch((err) => {
                reject(err);
            })
        })
    },

    getInstitutionByBrand({
        commit,
        state,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            if (state.institutionByBrand.length) {
                resolve(state.institutionByBrand);
                return;
            }
            G_transmit('getInstitutionByBrand', {
            }).then((res) => {
                const { status, data } = res;
                commit('meta', {
                    institutionByBrand: data
                })
                window.posthog?.register({
                    school_id: data?.id || '',
                    site_name: data.customName || ''    
                });
                resolve(data);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    getScoreMode({
        commit,
        state,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            G_transmit('getScoreModeConfig', {
            }).then((res) => {
                const { status, data } = res;
                commit('meta', {
                    scoreMode: data
                })
                resolve(data);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    'meta': (state, data) => {
        Object.assign(state, data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
